import http from './http-common'

export const getAll = () => {
    return http.get('/fecske/allergens').then((res) => {
        return res
    })
}
